import { render, staticRenderFns } from "./ConceptScheme.vue?vue&type=template&id=50f861ae"
import script from "./ConceptScheme.vue?vue&type=script&lang=js"
export * from "./ConceptScheme.vue?vue&type=script&lang=js"
import style0 from "./ConceptScheme.vue?vue&type=style&index=0&id=50f861ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports